(function () {
    'use strict';

    angular
        .module('app')
        .controller('CorporateTemplateViewController', cController);


    function cController($scope, $cookies, $location, $rootScope, $filter, $timeout, $state, $stateParams, CorporateTemplateService, toaster, cfpLoadingBar) {

        var model = this;

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            switch (userPermissionRow[0]) {
                case 2:
                    switch (userPermissionRow[1]) {
                        case 1:
                            model.CorporateTemplateRead = true;
                            break;
                        case 2:
                            model.CorporateTemplateEdit = true;
                            break;
                        default:
                    }
                    break;
                default:
            }
        });

        //validate if user access to Corporate Calender
        if (!model.CorporateTemplateRead) {
            $state.go('permissionDenied');
        }

        model.filterText = "";
        model.predicate = ""; model.reverse = false;
        model.orderby = function (predicate) {
            model.reverse = model.predicate == predicate ? !model.reverse : false;
            model.predicate = predicate;
        }


        model.Edit = function () {
            $state.go("linePlanTemplateEdit");
        }

        function getCurrentCorporateTemplateItems() {
            CorporateTemplateService.getCurrentCorporateTemplateItems().then(function (response) {
                if (response){
                    model.corporateTemplateItems = response;
                }
                else {
                    model.corporateTemplateItems = null;
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'No Corporate Template Items',
                        timeout: 5000
                    });
                }
                
            },
            function (error, status) {
                model.corporateTemplateItems = null;
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'There was some error while getting Corporate Items. Please contact system administrator',
                    timeout: 5000
                });
            });
        };

        //getCurrentCorporateTemplateItems();

    }

})();


(function () {
    'use strict';

    angular
        .module('app')
        .controller('CorporateTemplateEditController', cController);

    function cController($scope, $cookies, $location, $rootScope, $filter, $timeout, $state, $stateParams, $window, CorporateTemplateService, GroupService, toaster, cfpLoadingBar) {

        var model = this;

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        model.corporateTemplateItems = [];

        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            switch (userPermissionRow[0]) {
                case 2:
                    switch (userPermissionRow[1]) {
                        case 1:
                            model.CorporateTemplateRead = true;
                            break;
                        case 2:
                            model.CorporateTemplateEdit = true;
                            break;
                        default:
                    }
                    break;
                default:
            }
        });

        //validate if user access to Corporate Calendar
        if (!model.CorporateTemplateEdit) {
            $state.go('permissionDenied');
        }

        model.filterText = "";
        model.corporateTemplateItemData = [];

        $scope.tableBlur = function (n, o, arr, event) {
            if (arr[o].Sort !== arr[o].SortOriginal) {
                event.preventDefault();
                $scope.tableOrder(n, o, arr, event);
            }
        }

        $scope.tableOrder = function (n, o, arr, event, ri) {
            //if this isnt a re-index, dont run this code
            if (!ri) {
                //check the o.r., you like it so far?
                var oArr = arr;
                if (oArr == 'sortableTable1') {
                    arr = model.corporateTemplateItems;
                }

                //sort the model - only necessary on blur
                var dm = false;
                if (n === true) {
                    dm = arr[o].CalendarItemId;
                    arr.sort(function (a, b) {
                        return a.Sort - b.Sort;
                    });
                } else {
                    //dont do it if there is no old index
                    if (o !== false) {
                        //actually moving the index...
                        var obj = arr[o];
                        arr.splice(o, 1);
                        arr.splice(n, 0, obj);
                    }
                }
            };

            //reindex
            var i = 0;
            angular.forEach(arr, function (k, v) {
                if (dm) {
                    dm === k.CalendarItemId ? n = i : '';
                };
                i++;
                k.Sort = i * 10;
                k.SortOriginal = i * 10;
            });

            //update model
            $scope.$evalAsync(function () {
                $timeout(function () {
                    model.setIndexId(n);
                    $scope.focusElement.querySelectorAll('.focusInput')[0].focus();
                })
            });
        }

        $scope.startSortable = function (table) {
            var sortableTable = document.getElementById(table);
            $scope[table] = sortableTable;
            Sortable.create(sortableTable, {
                handle: '.draggable',
                animation: 150,
                onEnd: function (evt) {
                    $scope.tableOrder(evt.newIndex, evt.oldIndex, evt.from.id);
                }
            });
        }

        $scope.tableOrderKey = function (event, $index, array) {
            //backspace, tab, up, down, left, right arrows, enter
            var allowedKeys = [8, 9, 13, 37, 38, 39, 40, 46, 116];
            var allowedMetaKeys = [65, 86, 67, 88, 82, 90];
            //Ctrl, Ctrl + A, Ctrl + C, Ctrl + V, Ctrl + X, Ctrl + R, Ctrl + Z
            var eventKey = event.key;

            //no spacebar
            if (eventKey == " ") {
                eventKey = 'x';
                //just defaulting it to a value that isnt allowed
            }

            if (isNaN(eventKey) && eventKey !== 'Tab') {
                //if ctrl isnt being pressed
                var ctrlMeta = event.ctrlKey == true || event.metaKey == true;
                if (ctrlMeta) {
                    //move to first
                    if (event.keyCode == 38) {
                        $scope.tableOrder(0, $index, array, null);
                        $scope.focusElement = event.path[3].children[0];
                    }
                    //move to last
                    if (event.keyCode == 40) {
                        $scope.tableOrder(array.length - 1, $index, array, null);
                        $scope.focusElement = event.path[3].children[array.length - 1];
                    }
                } else {
                    if (allowedKeys.indexOf(event.keyCode) == -1) {
                        event.preventDefault();
                    }
                    if (allowedMetaKeys.indexOf(event.keyCode) > -1) {
                        event.preventDefault();
                    }

                    //move up 1
                    if (event.keyCode == 38) {
                        if ($index !== 0) {
                            $scope.tableOrder($index - 1, $index, array, null);
                            $scope.focusElement = event.path[3].children[$index - 1];
                        }
                    }

                    //move down 1
                    if (event.keyCode == 40) {
                        if ($index !== array.length - 1) {
                            $scope.tableOrder($index + 1, $index, array, null);
                            $scope.focusElement = event.path[3].children[$index + 1];
                        }
                    }
                }
            }
        };

        //default sort order set to false (desc) so when you first click, its asc
        $scope.tableSortDir = '';
        $scope.tableSort = function (h) {
            if (h !== $scope.tableSortName) {
                //reset order direction if new name is chosen
                $scope.tableSortDir = '';
            }

            $scope.tableSortName = h;

            if ($scope.tableSortDir === '') { //first click
                $scope.tableSortDir = false
                $scope.tableSortClass = 'fa-caret-up';
            } else if ($scope.tableSortDir === false) { //second click
                $scope.tableSortDir = true
                $scope.tableSortClass = 'fa-caret-down';
            } else { //third click, reset it all
                $scope.tableSortDir = '';
                $scope.tableSortClass = '';
                $scope.tableSortName = '';
            }
        }

        //Set Selected Row
        model.setIndexId = function (currentIndex) {
            model.indexId = currentIndex;
        }

        model.View = function () {
            $state.go("linePlanTemplateView");
        }

        model.Save = function (isFormInvalid) {
            if (!isFormInvalid) {
                $scope.corporateTemplateForm.$setPristine();                

                for (var i = 0; i < model.corporateTemplateItems.length; i++) {

                    model.corporateTemplateItemData.push({
                        CorporateTemplateItemId: model.corporateTemplateItems[i].CorporateTemplateItemId,
                        Name: model.corporateTemplateItems[i].Name,
                        Stage: model.corporateTemplateItems[i].Stage,
                        Sort: model.corporateTemplateItems[i].Sort,
                        GroupId: model.corporateTemplateItems[i].GroupId
                    });
                }

                CorporateTemplateService.createCorporateTemplate(model.corporateTemplateItemData)
                    .then(function (response) {
                        //$state.go("linePlanTemplateView");
                        model.corporateTemplateItemData = [];
                        getCurrentCorporateTemplateItems();
                        getGroupList();
                        toaster.pop({
                            type: 'success',
                            title: 'Success!',
                            body: 'Record saved successfully',
                            timeout: 5000
                        });
                        $scope.corporateTemplateForm.$setPristine();
                        $scope.corporateTemplateForm.$setUntouched();
                    }, function (error, status) {
                        toaster.pop({
                            type: 'error',
                            title: 'Error!',
                            body: 'There was an error while saving the record. Please contact system administrator',
                            timeout: 5000
                        });
                        $scope.corporateTemplateForm.$setPristine();
                        $scope.corporateTemplateForm.$setUntouched();
                    });
            } else {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'Please fill all required fields',
                    timeout: 5000
                });
            }
        }

        model.addRow = function (idx, arr, a, t) {
            var item = { CorporateTemplateItemId: model.corporateTemplateId, CalendarItemId: 0, Sort: 0, CalendarItemTypeId: 1, Stage: "", Name: "", StartDate: "", EndDate: "", GroupName: "", isEdit: true };
            arr.splice(idx + a, 0, item);
            var e = document.getElementById(t)
            $scope.focusElement = e.children[idx + a];
            $scope.tableOrder(idx + a, false, arr, true);
        }

        model.CancelRow = function (currentIndex, arr) {
            if ($window.confirm("This action will delete the current row. Do you want to continue?")) {
                arr.splice(currentIndex, 1);
                $scope.tableOrder(currentIndex, false, arr);
            }
        }

        function getCurrentCorporateTemplateItems() {
            model.corporateTemplateItemData = [];
            CorporateTemplateService.getCurrentCorporateTemplateItems().then(function (response) {
                if (response) {
                    model.corporateTemplateItems = response;
                    model.corporateTemplateId = response[0].CorporateTemplateItemId;

                    //assign SortOriginal to use for detecting if a value was actually changed
                    angular.forEach(model.corporateTemplateItems, function (k) {
                        k.SortOriginal = k.Sort;
                    })
                }
                else {
                    model.corporateTemplateItems = null;
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'No Corporate Template Items',
                        timeout: 5000
                    });
                }
            },
            function (error, status) {
                model.corporateTemplateItems = null;
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'No Corporate Template Items',
                    timeout: 5000
                });
            });
        };

        function getGroupList() {
            GroupService.getGroupList().then(function (response) {
                model.groups = response;
            });
        }

        //getCurrentCorporateTemplateItems();
        //getGroupList();
    }
})();
